import { Component } from 'react';

export class VisaSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                width="70"
                height="40"
                viewBox="0 0 47 22"
                fill="none"
                data-testid="VisaSVG"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H47V22H0V0Z"
                    fill="white"
                />
                <path
                    d="M2.98966 11.5228H0L1.86995 0H4.85944L2.98966 11.5228Z"
                    transform="translate(17.4487 4.75586)"
                    fill="#00579F"
                />
                <path
                    d="M8.96815 0.490569C8.37846 0.257423 7.44316 0 6.28667 0C3.33428 0 1.25524 1.56897 1.24249 3.81214C1.21797 5.46713 2.73102 6.38636 3.86267 6.93819C5.01933 7.50208 5.41251 7.87013 5.41251 8.37275C5.40074 9.14469 4.47786 9.50052 3.61711 9.50052C2.42351 9.50052 1.78395 9.31707 0.812032 8.8876L0.418359 8.70349L0 11.2901C0.701189 11.6085 1.99305 11.891 3.33428 11.9034C6.47124 11.9034 8.5135 10.3587 8.5377 7.96821C8.54963 6.65649 7.75068 5.6514 6.0282 4.8301C4.98254 4.30287 4.34217 3.94736 4.34217 3.40792C4.35443 2.91751 4.8838 2.41521 6.06416 2.41521C7.03608 2.39061 7.75019 2.62343 8.29116 2.85641L8.56157 2.97877L8.96815 0.490569Z"
                    transform="translate(22.3081 4.54688)"
                    fill="#00579F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.00342 0H8.31592L10.7278 11.5225H7.95972C7.95972 11.5225 7.68872 10.1982 7.60278 9.79395H3.7644L3.13696 11.5225H0L4.44067 0.956055C4.74854 0.208008 5.29028 0 6.00342 0ZM5.81909 4.2168L4.62549 7.44043H7.11035C6.98755 6.86426 6.42139 4.10645 6.42139 4.10645L6.2124 3.11328C6.12549 3.36523 6.00073 3.71094 5.91504 3.94727L5.81909 4.2168Z"
                    transform="translate(30.6243 4.75586)"
                    fill="#00579F"
                />
                <path
                    d="M7.3812 0L4.45334 7.85742L4.1334 6.26384C3.5921 4.42506 1.89447 2.42727 0 1.43391L2.68181 11.5105H5.8433L10.5425 0H7.3812V0Z"
                    transform="translate(7.57056 4.75586)"
                    fill="#00579F"
                />
                <path
                    d="M4.85928 0H0.0492091L0 0.232821C3.75215 1.18903 6.23713 3.49394 7.2581 6.26433L6.21244 0.968593C6.04029 0.232658 5.51126 0.0242759 4.85928 0Z"
                    transform="translate(4.4458 4.75586)"
                    fill="#FAA61A"
                />
            </svg>
        );
    }
}
